import { PinTemplateInterface } from '../interfaces/pin-template.interface';

export class PinTemplate implements PinTemplateInterface {
  /**
   * Id.
   */
  public id: number;

  /**
   * File name.
   */
  public fileName: string;

  /**
   * UUID.
   */
  public fileUuid: string;

  /**
   * Creation date.
   */
  public createdDate: number;

  /**
   * Created by.
   */
  public createdBy: number;

  /**
   * PinTemplate constructor.
   *
   * @param jsonData Pin Template data.
   */
  constructor(jsonData: PinTemplateInterface) {
    if (jsonData) {
      this.id = jsonData.id;
      this.fileName = jsonData.fileName;
      this.fileUuid = jsonData.fileUuid;
      this.createdDate = jsonData.createdDate;
      this.createdBy = jsonData.createdBy;
    }
  }
}
